import React from 'react'
import "./about.css";
const About = () => {
  return (
    <div className='about-main'>
      <h1 >About Us</h1>
      <div className='aboutus'>
        <div>
          <img src="https://avatars.githubusercontent.com/u/105980445?v=4" alt="rittik" />
          <a href="https://rittik24.github.io/"> <h1>Rittik Haldar</h1></a>
          <h3>Worked on full Navbar page by using HTML CSS  React-icon and Chakra-UI</h3>
        </div>
        <div>
        <img src="https://avatars.githubusercontent.com/u/107460084?v=4" alt="anirudha" />
        <a href="https://crusher8010.github.io/"><h1>Anirudha Mandal</h1></a>
          <h3>Worked on Home page by using HTML CSS  React-icon and Chakra-UI</h3>
        </div>
        <div>
        <img src="https://avatars.githubusercontent.com/u/107461782?v=4" alt="aniket" />
        <a href="https://aniketpandey2912.github.io/"> <h1>Aniket Pandey</h1></a>
          <h3>Worked on Admin page by using HTML CSS  React-icon and Chakra-UI</h3>
        </div>
        <div>
        <img src="https://avatars.githubusercontent.com/u/97180521?v=4" alt="moumita" />
        <a href="https://moumita7.github.io/"> <h1>Moumita Das</h1></a>
          <h3>Worked on BuyPlan page by using HTML CSS  React-icon and Chakra-UI</h3>
        </div>
        <div>
        <img src="https://avatars.githubusercontent.com/u/107640190?v=4" alt="sajan" />
        <a href="https://sajan1789.github.io/"> <h1>Sajan Kumar</h1></a>
          <h3>Worked on Login & Footer page by using HTML CSS  React-icon and Chakra-UI</h3>
        </div>
      </div>
    </div>
  )
}

export default About;